import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { DialogsService } from '@services/dialogs-service';
import { NavigationService } from '@services/navigation-service';
import { Router } from '@angular/router';
import { PATH_FINANCIERA } from '../../../../navigation/navigation.module';
import * as moment from 'moment';
import { PricePipe } from '@utils/pipes/price';
import { SpinnerService } from '@services/spinner-service';
import { MdSnackBar } from '@angular/material';
import { PermisosService } from '@services/permisos-service';
import { FinancieraService } from '@services/financiera-service';
import {PageHeaderComponent} from '@common/page-header';
import {Breakpoints, BreakpointsObserverService} from '@services/breakpoints-observer.service';
import {ResponsiveService} from '@services/responsive.service';

@Component({
  selector: 'app-validate-precio-financiera',
  templateUrl: './validate-precio-financiera.component.html',
  styleUrls: ['./validate-precio-financiera.component.scss']
})
export class ValidatePrecioFinancieraComponent implements OnInit {

  columns = ['Acción', 'Fecha de Cotización', 'Entidad', 'Subtipo', 'Moneda', 'Precio', 'Varianza', 'Responsable'];
  columnWidth = ['10%', '13.33%', '13.33%', '13.33%', '8.33%', '8.33%', '8.33%', '25%'];

  precios = [];

  private maxDate = moment().add(1, 'days').toDate();

  public dummyDateContainer = null;
  public editFechaId = 0;
  @ViewChild('datePicker') datePicker;
  @ViewChild(PageHeaderComponent) pageHeader: PageHeaderComponent
  web = true;

  constructor(private dialogsService: DialogsService,
              private navService: NavigationService,
              private location: Location,
              private router: Router,
              private pricePipe: PricePipe,
              private spinnerService: SpinnerService,
              private snackBar: MdSnackBar,
              private permisosService: PermisosService,
              private financieraService: FinancieraService,
              private breakpointsService: BreakpointsObserverService,
              private responsiveService: ResponsiveService,
  ) {
    this.permisosService.verificarAccesoDeURL();
    breakpointsService.observe([Breakpoints.Web]).subscribe(x => {
      this.web = x.matches && responsiveService._isDesktop;
    });
  }

  ngOnInit() {
    // obtenemos los precios a validar
    this.spinnerService.setSoftSpinnerShowFlag(true);
    this.financieraService.getPreciosValidar()
      .subscribe(res => {
        if (res) {
          this.precios = res.map(prec => ({
            id: prec.Id,
            fecha: moment(prec.FechaCotizacion * 1000).toDate(),
            fechaOriginal: moment(prec.FechaCotizacion * 1000).toDate(),
            moneda: prec.Moneda.Simbolo,
            precio: prec.Valor,
            responsable: prec.UsuarioCreador.UserFullName,
            checked: false,
            // precio original cargado antes de ser este editado, se usa para verificar si hubo ediciones de precio
            precioOriginal: prec.Valor,
            monedaId: prec.Moneda.Id,
            banco: prec.SubentidadFinanciera.EntidadFinanciera.Nombre,
            subentidad: prec.SubentidadFinanciera.Nombre,
            varianza: prec.Varianza,
            precioAnterior: prec.Valor - prec.Varianza,
            EntidadFinanciera: prec.SubentidadFinanciera.EntidadFinanciera,
          }));
        }
        this.spinnerService.setSoftSpinnerShowFlag(false);
      }, err => {
        this.spinnerService.setSoftSpinnerShowFlag(false);
      });
  }

  getCellValue(index, col) {
    switch (col) {
      case 'Fecha de Cotización':
        return moment(this.precios[index].fecha).format('DD/MM/YY');
      case 'Moneda':
        return this.precios[index].moneda;
      case 'Precio':
        return this.pricePipe.transform(this.precios[index].precio, 'fill,2');
      case 'Responsable':
        return this.precios[index].responsable;
      case 'Entidad':
        return this.precios[index].banco;
      case 'Subtipo':
        return this.precios[index].subentidad;
      case 'Varianza':
        // si hubo un cambio de fecha, no sabemos la cotizacion de dicha fecha por lo que es imposible conocer la varianza resultante
        return moment(this.precios[index].fechaOriginal).format('DD/MM/YY') === moment(this.precios[index].fecha).format('DD/MM/YY') ?
          this.pricePipe.transform(this.precios[index].varianza, 'clamp') : '-';
    }
  }

  onValidateChange(index, e) {
    this.precios[index].checked = e.checked;
  }

  onDeleteToggle(index) {
    const idToDelete = this.precios[index].id;
    this.dialogsService.confirm(
      '¿ESTÁ SEGURO QUE DESEA RECHAZAR ESTE PRECIO?',
      this.precios[index].banco.toUpperCase() + ' ' +
      this.precios[index].moneda + ' ' +
      this.pricePipe.transform(this.precios[index].precio),
      'RECHAZAR',
      'CANCELAR')
      .subscribe(x => {
        if (x) {
          this.spinnerService.setShowFlag(true);
          this.financieraService.rechazarPrecio(idToDelete)
            .subscribe(res => {
              if (res) {
                this.precios = this.precios.filter(y => y.id !== idToDelete);
                this.spinnerService.setShowFlag(false);
              }
            }, (err) => {
              this.spinnerService.setShowFlag(false);
            });
        }
      });
  }

  getvalueTooltip(index, col) {
    if (col === 'precio') {
      if (this.precios[index].precio !== this.precios[index].precioOriginal) {
        return 'Editado. Precio Original: ' + this.pricePipe.transform(this.precios[index].precioOriginal, 'clamp');
      }
    }
    return '';
  }

  onEditNumber(index) {
    this.dialogsService.showEditNumberDialog('EDITAR PRECIO', this.precios[index].precio, false, false, 'Precio')
      .subscribe(res => {
        if (res || res === 0) {
          this.precios[index].precio = res;
          this.precios[index].checked = true;
          this.precios[index].varianza = res - this.precios[index].precioAnterior;
        }
      });
  }

  navigateBack() {
    let hasChanges = false;
    this.precios.forEach(val => {
      if (val.checked || val.precioOriginal !== val.precio) {
        hasChanges = true;
      }
    });
    if (hasChanges) {
      this.dialogsService.confirm(null,
        '¿Está seguro de salir sin validar estos precios?',
        'SÍ, ACEPTAR',
        'NO, CANCELAR')
        .subscribe(res => {
          if (res) {
            this.pageHeader.catchEnded();
          }
        });
    } else {
      this.pageHeader.catchEnded();
    }
  }

  onSubmit() {
    // antes de enviar los precios, verificamos si hay entidades que requieren validacion conjunta.
    // usamos un ciclo for para poder usar el break
    let stopSubmit = false;
    for (let i = 0; i < this.precios.length; i++) {
      // verificamos si el precio que estamos validando esta activo
      if (!this.precios[i].checked) {
        continue;
      }

      // si esta activo verificamos si su entidad financiera requiere validacion conjunta
      if (!this.precios[i].EntidadFinanciera.ValidacionConjunta) {
        continue;
      }

      // si posee validacion conjunta verificamos que todos los precios conjuntos esten activos
      const preciosConjuntos = this.precios.filter(x => x.EntidadFinanciera.ID === this.precios[i].EntidadFinanciera.ID);
      if (!preciosConjuntos.every(x => {return x.checked})) {
        this.snackBar.open(
          `La entidad ${this.precios[i].EntidadFinanciera.Nombre} requiere que todas sus subentidades sean validadas`,
          null,
          {duration: 5000}
        );
        stopSubmit = true;
        break;
      }
    }

    if (stopSubmit) {return;}
    const pricesValidated = [];
    this.precios.forEach(val => {
      if (val.checked) {
        pricesValidated.push(val);
      }
    });
    if (pricesValidated.length) {
      this.dialogsService.confirm('¿Está seguro que desea validar estos precios?', null, 'Si, Aceptar', 'No, Cancelar')
        .subscribe(x => {
          if (x) {
            let pricesToSend;
            pricesToSend = pricesValidated.map(pr => ({
              Id: pr.id,
              Valor: pr.precio,
              FechaCotizacion: moment(pr.fecha).unix()
            }));

            this.spinnerService.setShowFlag(true);

            this.financieraService.publicarPrecios(pricesToSend)
              .subscribe(res => {
                this.spinnerService.setShowFlag(false);
                if (res) {
                  this.router.navigateByUrl('/' + PATH_FINANCIERA);
                }
              }, (err) => {
                this.spinnerService.setShowFlag(false);
              });
          }
        });
    } else {
      this.snackBar.open('Es necesario seleccionar al menos un precio para validar', '', {
        duration: 2000,
      });
    }
  }

  onEditFecha(rowIndex) {
    // guardamos la posicion del picker seleccionado
    this.editFechaId = rowIndex;
    this.dummyDateContainer = null;
    setTimeout(_ => {
      this.datePicker.open();
    }, 100);
  }

  onFechaEdited(e) {
    this.precios[this.editFechaId].fecha = moment(e).toDate();
    this.precios[this.editFechaId].checked = true;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/validate-precio-financiera/validate-precio-financiera.component.ts